import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../ui/Icon';
import { getPrimaryNav, isNavItemActive, isMoreActive } from './adminNav';
import { useAdminShell } from './AdminContext';

/** Phone/tablet navigation — the same bottom-bar language as the student product: four role-specific
 *  destinations plus "More" (opens the sheet with everything else). Hidden from 900px (top tabs take over). */
export default function AdminBottomNav() {
  const { pathname, search } = useLocation();
  const { isSuper, openNav, navOpen } = useAdminShell();
  const moreActive = isMoreActive(isSuper, pathname, search);
  return (
    <nav className="az-bottomnav" aria-label="Primary">
      {getPrimaryNav(isSuper).map(item => {
        const active = isNavItemActive(item, pathname, search);
        return (
          <Link key={item.path} to={item.path} className={`az-bottomnav-item${active ? ' active' : ''}`} aria-current={active ? 'page' : undefined}>
            <span className="az-bottomnav-icon"><Icon name={item.icon} size={22} strokeWidth={active ? 2.4 : 2} /></span>
            <span className="az-bottomnav-label">{item.label}</span>
          </Link>
        );
      })}
      <button type="button" className={`az-bottomnav-item${moreActive ? ' active' : ''}`} onClick={openNav} aria-haspopup="dialog" aria-expanded={navOpen}>
        <span className="az-bottomnav-icon"><Icon name="more" size={22} strokeWidth={moreActive ? 2.4 : 2} /></span>
        <span className="az-bottomnav-label">More</span>
      </button>
    </nav>
  );
}
